const TEMPLATE_NAME = 'PATIENT_FILES';

const TYPES = {
    1: 'authorization',
    2: 'exam',
    3: 'prescription',
    4: 'provision',
};

const initialState = () => ({
    loading: false,
    uploading: false,
    files: {
        authorization: [],
        exam: [],
        prescription: [],
        provision: [],
    },
});

const reducer = (state = initialState(), action) => {
    switch (action.type) {
        case `${TEMPLATE_NAME}_PENDING`: {
            return {
                ...state,
                loading: true,
            };
        }
        case `${TEMPLATE_NAME}_REJECTED`: {
            return {
                ...state,
                loading: false,
            };
        }
        case `${TEMPLATE_NAME}_FULFILLED`: {
            const files = action.payload;
            return {
                ...state,
                loading: false,
                files,
            };
        }
        case `${TEMPLATE_NAME}_DELETE`: {
            const deletedRow = action.payload;
            const files = state.files;
            const data = state.files[TYPES[deletedRow.type]].filter(row => row.id !== deletedRow.id);
            files[TYPES[deletedRow.type]] = data;
            
            return {
                ...state,
                loading: false,
                files,
            };
        }
        case `${TEMPLATE_NAME}_UPLOAD_PENDING`: {
            return {
                ...state,
                uploading: true,
                loading: true,
            };
        }
        case `${TEMPLATE_NAME}_UPLOAD_REJECTED`: {
            return {
                ...state,
                uploading: false,
                loading: false,
                error: action.payload,
            };
        }
        case `${TEMPLATE_NAME}_UPLOAD_FULFILLED`: {
            const newRow = action.payload;
            newRow.new = true;
            const files = state.files;
            
            if(!files[TYPES[newRow.type]]) {
                files[TYPES[newRow.type]] = [];
                files[TYPES[newRow.type]].unshift(newRow);
            } else {
                files[TYPES[newRow.type]].unshift(newRow);
            }

            return {
                ...state,
                loading: false,
                uploading: false,
                files,
            };
        }
        case `${TEMPLATE_NAME}_RESET`: {
            return initialState();
        }

        default:
            return state;
    }
};

export default reducer;
